import React, { useState } from 'react';
import { FormSection } from '../playbooks/editorBits';

export default function SchemaAutomationPanel({ schema, canManage, onSave }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  if (!schema?.id) return null;
  return (
    <FormSection title="Automatic processing" hint="Checks every minute for matching, reviewed contracts with a document and no saved result. Enabling this also fills existing gaps. Failed runs need a manual retry; existing results are not rerun automatically.">
      <label className="row" style={{ gap: 8 }}>
        <input
          type="checkbox"
          checked={!!schema.autoRun}
          disabled={!canManage || saving}
          onChange={async (event) => {
            const enabled = event.target.checked;
            setSaving(true);
            setError('');
            try { await onSave(enabled); } catch (err) { setError(err.message); }
            finally { setSaving(false); }
          }}
        />
        Process new matching contracts automatically
      </label>
      {!canManage && <p className="muted" style={{ fontSize: 12 }}>An admin can change this setting.</p>}
      {!schema.active && <p className="muted" style={{ fontSize: 12 }}>Processing is paused while this schema is inactive.</p>}
      {error && <p role="alert" className="text-red-600">{error}</p>}
    </FormSection>
  );
}
